export { NewPassword } from "./new_password";
